/* Manu AI v17 (22/10/2026) — plusieurs designs (équipes) + lien de sauvegarde.
 * - « Décliner pour une autre personne » : Manu demande ce qui change (nom ou texte, couleurs, autre chose) et sur quelle face,
 *   puis retouche le design validé (même moteur que « Refaire », v15). Le résultat devient un nouvel onglet.
 * - Onglets : un design par personne. Chacun suit le même parcours : Valider → vêtement → fiche de personnalisation.
 *   Le panier de designs est rangé dans IndexedDB (base rxManuBasket, 14 jours) sur l'appareil du visiteur.
 * - Lien de sauvegarde : « Copier le lien » envoie les designs de Manu (jamais l'image importée par le visiteur) à /api/studio
 *   (action share-save, Vercel Blob, 90 jours) et donne /?manu_share=<id> pour les rouvrir sur n'importe quel appareil.
 * S'appuie sur l'instance de assets/ai-studio.js (section._ais), enrichie par v9 → v16, chargés avant. */
(function () {
  'use strict';

  var DB = 'rxManuBasket', MAX = 12, KEEP = 14 * 86400000;
  var TXT = {
    fr: {
      decl: 'Décliner pour une autre personne', tabs: 'Mes designs', n: 'Design {n}', sent: 'envoyé vers la personnalisation', rm: 'Retirer ce design', share: 'Copier le lien',
      q1: 'Qu’est-ce qui change pour cette personne ?', kText: 'Le nom ou le texte', kColors: 'Les couleurs', kIdea: 'Autre chose',
      q2: 'Sur quelle face ?', both: 'Les deux', askText: 'Quel nom ou texte pour cette personne ?', askIdea: 'Décris ce qui change, je ne touche qu’à ça.',
      go: 'Je prépare le design pour {name}…', max: 'Tu as atteint 12 designs, c’est le maximum pour une même commande.',
      copied: 'Lien copié. Il garde tes designs {d} jours : ouvre-le sur n’importe quel appareil pour les retrouver.', link: 'Ton lien : {u}',
      fail: 'Je n’arrive pas à créer le lien pour l’instant. Réessaie dans un moment.', big: 'Ces designs sont trop lourds pour un seul lien. Retire-en quelques-uns et réessaie.', none: 'Aucun design de Manu à enregistrer.',
      wait: 'Création du lien…', noblob: 'Le stockage des liens n’est pas encore relié côté serveur (Blob). Dis-le à RXWEAR.',
      gone: 'Ce lien n’est plus valable : les liens gardent les designs 90 jours.'
    },
    en: {
      decl: 'Make a version for someone else', tabs: 'My designs', n: 'Design {n}', sent: 'sent to customisation', rm: 'Remove this design', share: 'Copy link',
      q1: 'What changes for this person?', kText: 'The name or text', kColors: 'The colours', kIdea: 'Something else',
      q2: 'On which side?', both: 'Both', askText: 'Which name or text for this person?', askIdea: 'Describe what changes, I will only touch that.',
      go: 'Preparing the design for {name}…', max: 'You have reached 12 designs, the maximum for one order.',
      copied: 'Link copied. It keeps your designs for {d} days: open it on any device to find them again.', link: 'Your link: {u}',
      fail: 'I cannot create the link right now. Try again in a moment.', big: 'These designs are too heavy for a single link. Remove a few and try again.', none: 'No Manu design to save.',
      wait: 'Creating the link…', noblob: 'Link storage is not connected on the server yet (Blob). Let RXWEAR know.',
      gone: 'This link is no longer valid: links keep designs for 90 days.'
    },
    es: {
      decl: 'Crear una versión para otra persona', tabs: 'Mis diseños', n: 'Diseño {n}', sent: 'enviado a la personalización', rm: 'Quitar este diseño', share: 'Copiar enlace',
      q1: '¿Qué cambia para esta persona?', kText: 'El nombre o el texto', kColors: 'Los colores', kIdea: 'Otra cosa',
      q2: '¿En qué cara?', both: 'Las dos', askText: '¿Qué nombre o texto para esta persona?', askIdea: 'Describe qué cambia, solo tocaré eso.',
      go: 'Preparo el diseño para {name}…', max: 'Has llegado a 12 diseños, el máximo para un mismo pedido.',
      copied: 'Enlace copiado. Guarda tus diseños {d} días: ábrelo en cualquier dispositivo para recuperarlos.', link: 'Tu enlace: {u}',
      fail: 'No puedo crear el enlace ahora. Inténtalo de nuevo en un momento.', big: 'Estos diseños pesan demasiado para un solo enlace. Quita algunos e inténtalo de nuevo.', none: 'No hay ningún diseño de Manu para guardar.',
      wait: 'Creando el enlace…', noblob: 'El almacenamiento de enlaces aún no está conectado en el servidor (Blob). Avisa a RXWEAR.',
      gone: 'Este enlace ya no es válido: los enlaces guardan los diseños 90 días.'
    },
    de: {
      decl: 'Für eine andere Person abwandeln', tabs: 'Meine Entwürfe', n: 'Entwurf {n}', sent: 'zur Personalisierung geschickt', rm: 'Diesen Entwurf entfernen', share: 'Link kopieren',
      q1: 'Was ändert sich für diese Person?', kText: 'Name oder Text', kColors: 'Die Farben', kIdea: 'Etwas anderes',
      q2: 'Auf welcher Seite?', both: 'Beide', askText: 'Welcher Name oder Text für diese Person?', askIdea: 'Beschreibe, was sich ändert, ich ändere nur das.',
      go: 'Ich bereite den Entwurf für {name} vor …', max: 'Du hast 12 Entwürfe erreicht, das Maximum für eine Bestellung.',
      copied: 'Link kopiert. Er bewahrt deine Entwürfe {d} Tage auf: Öffne ihn auf jedem Gerät, um sie wiederzufinden.', link: 'Dein Link: {u}',
      fail: 'Ich kann den Link gerade nicht erstellen. Versuche es gleich noch einmal.', big: 'Diese Entwürfe sind für einen Link zu groß. Entferne einige und versuche es erneut.', none: 'Kein Manu-Entwurf zum Speichern.',
      wait: 'Link wird erstellt …', noblob: 'Der Link-Speicher ist auf dem Server noch nicht verbunden (Blob). Sag RXWEAR Bescheid.',
      gone: 'Dieser Link ist nicht mehr gültig: Links bewahren Entwürfe 90 Tage auf.'
    },
    it: {
      decl: 'Crea una versione per un’altra persona', tabs: 'I miei design', n: 'Design {n}', sent: 'inviato alla personalizzazione', rm: 'Rimuovi questo design', share: 'Copia link',
      q1: 'Cosa cambia per questa persona?', kText: 'Il nome o il testo', kColors: 'I colori', kIdea: 'Altro',
      q2: 'Su quale lato?', both: 'Entrambi', askText: 'Quale nome o testo per questa persona?', askIdea: 'Descrivi cosa cambia, tocco solo quello.',
      go: 'Preparo il design per {name}…', max: 'Hai raggiunto 12 design, il massimo per un ordine.',
      copied: 'Link copiato. Conserva i tuoi design per {d} giorni: aprilo su qualsiasi dispositivo per ritrovarli.', link: 'Il tuo link: {u}',
      fail: 'Non riesco a creare il link in questo momento. Riprova tra poco.', big: 'Questi design sono troppo pesanti per un solo link. Rimuovine qualcuno e riprova.', none: 'Nessun design di Manu da salvare.',
      wait: 'Creo il link…', noblob: 'L’archivio dei link non è ancora collegato sul server (Blob). Avvisa RXWEAR.',
      gone: 'Questo link non è più valido: i link conservano i design per 90 giorni.'
    }
  };
  // Consignes envoyées au modèle d'image (anglais, toujours)
  var EDIT = {
    colors: 'Change the colour palette to a different bold combination that stays readable on fabric. Keep the drawing, composition and lettering shapes identical.',
    text: function (x) { return 'Replace the text with exactly: "' + x + '" (spelled exactly). Keep the same lettering style, colours and layout. Change nothing else.'; }
  };
  var ICON = {
    link: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1.5 1.5"/><path d="M14 11a5 5 0 0 0-7.07 0l-3 3A5 5 0 0 0 11 21.07l1.5-1.5"/></svg>',
    check: '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5"/></svg>',
    x: '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>'
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rep(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function clone(o) { return JSON.parse(JSON.stringify(o)); }

  /* ---------- IndexedDB : un seul enregistrement « basket » ---------- */
  function idb(mode, fn) {
    return new Promise(function (res, rej) {
      if (!window.indexedDB) { rej(new Error('no-idb')); return; }
      var r = indexedDB.open(DB, 1);
      r.onupgradeneeded = function () { r.result.createObjectStore('kv'); };
      r.onerror = function () { rej(r.error); };
      r.onsuccess = function () {
        var db = r.result, t = db.transaction('kv', mode), q = fn(t.objectStore('kv'));
        t.oncomplete = function () { db.close(); res(q ? q.result : undefined); };
        t.onerror = t.onabort = function () { db.close(); rej(t.error); };
      };
    });
  }

  /* ---------- Rognage du logo (la vue d'édition utilise une image rognée, non stockée) ---------- */
  function trimAlpha(src) {
    return new Promise(function (res) {
      var i = new Image();
      i.onload = function () {
        try {
          var w = i.naturalWidth, h = i.naturalHeight, c = document.createElement('canvas'), x = c.getContext('2d');
          c.width = w; c.height = h; x.drawImage(i, 0, 0);
          var d = x.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1, px, py;
          for (py = 0; py < h; py++) for (px = 0; px < w; px++) if (d[(py * w + px) * 4 + 3] > 8) { if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py; }
          if (x1 < 0) { res({ png: src, w: w, h: h }); return; }
          var tw = x1 - x0 + 1, th = y1 - y0 + 1, o = document.createElement('canvas');
          o.width = tw; o.height = th; o.getContext('2d').drawImage(c, x0, y0, tw, th, 0, 0, tw, th);
          res({ png: o.toDataURL('image/png'), w: tw, h: th });
        } catch (e) { res({ png: src, w: i.naturalWidth || 1, h: i.naturalHeight || 1 }); }
      };
      i.onerror = function () { res({ png: src, w: 1, h: 1 }); };
      i.src = src;
    });
  }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v17) return;
    inst._v17 = true;
    var bk = inst.bk = { designs: [], active: null };
    function tx() { return TXT[inst.loc] || TXT.fr; }
    function find(id) { return bk.designs.filter(function (d) { return d.id === id; })[0] || null; }
    function persist() { idb('readwrite', function (st) { return st.put({ designs: bk.designs, active: bk.active, at: Date.now() }, 'basket'); }).catch(function () {}); }

    /* ---------- Instantané d'un design (sans l'image rognée, recalculée à l'ouverture) ---------- */
    function slimFace(f) { return f && f.src && !f.own && !f.mock ? { src: f.src, w: f.w, h: f.h } : null; }
    function hasManu(s) { return !!(s.faces && (slimFace(s.faces.front) || slimFace(s.faces.back))); }
    function ownFace(s) { return ['front', 'back'].some(function (k) { return s.faces[k] && (s.faces[k].own || s.faces[k].mock); }); }
    function snap() {
      var s = inst.s;
      return {
        faces: { front: slimFace(s.faces.front), back: slimFace(s.faces.back) }, pos: clone(s.pos || {}), edit: s.edit,
        sides: s.sides || null, frontFmt: s.frontFmt || null, idea: String(s.idea || '').slice(0, 200), logoText: s.logoText || null, noText: !!s.noText,
        sport: s.sport || null, niche: s.niche || null, style: s.style || null, color: s.color || 'noir', support: s.support ? s.support.h : null
      };
    }
    function labelOf(snp, n) { var x = String(snp.logoText || '').trim(); return x ? x.slice(0, 14) : rep(tx().n, { n: n }); }
    // Range le design affiché dans l'onglet actif (force : crée l'onglet, au premier « Décliner »)
    function commit(force) {
      var s = inst.s;
      if (!s || !s.faces || !hasManu(s) || ownFace(s)) return null;
      if (!s.saveId) s.saveId = uid();
      var e = find(s.saveId);
      if (!e) {
        if (!force) return null;
        e = { id: s.saveId, name: null, sent: false, snap: null };
        bk.designs.push(e);
      }
      e.snap = snap();
      if (!e.name) e.name = labelOf(e.snap, bk.designs.indexOf(e) + 1);
      bk.active = e.id;
      persist(); renderTabs();
      return e;
    }

    /* ---------- Barre d'onglets ---------- */
    var bar = document.createElement('div');
    bar.className = 'ais-dtabs'; bar.hidden = true;
    inst.thread.parentNode.insertBefore(bar, inst.thread);
    function renderTabs() {
      var T = tx();
      if (bk.designs.length < 2) { bar.hidden = true; bar.innerHTML = ''; return; }
      bar.hidden = false;
      bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', T.tabs);
      bar.innerHTML = '<div class="ais-dtabs__list">' + bk.designs.map(function (d) {
        var on = d.id === (inst.s && inst.s.saveId), f = d.snap.faces.front || d.snap.faces.back;
        return '<span class="ais-dtab' + (on ? ' is-on' : '') + '">' +
          '<button type="button" class="ais-dtab__b" data-dtab="' + esc(d.id) + '" aria-pressed="' + on + '">' +
          (f ? '<img src="' + esc(f.src) + '" alt="" width="28" height="28">' : '') +
          '<span class="ais-dtab__n">' + esc(d.name) + '</span>' + (d.sent ? '<span class="ais-dtab__ok" role="img" aria-label="' + esc(T.sent) + '">' + ICON.check + '</span>' : '') + '</button>' +
          (on ? '<button type="button" class="ais-dtab__x" data-drm="' + esc(d.id) + '" aria-label="' + esc(T.rm) + '">' + ICON.x + '</button>' : '') + '</span>';
      }).join('') + '</div><button type="button" class="ais-dtabs__share" data-dshare>' + ICON.link + '<span>' + esc(T.share) + '</span></button>';
    }
    bar.addEventListener('click', function (e) {
      if (inst.busy) return;
      var b = e.target.closest('[data-dtab]'), x = e.target.closest('[data-drm]'), sh = e.target.closest('[data-dshare]');
      if (b) openTab(b.getAttribute('data-dtab'));
      else if (x) removeTab(x.getAttribute('data-drm'));
      else if (sh) shareLink();
    });

    /* ---------- Restaurer un design dans l'éditeur ---------- */
    function restore(d, keepThread) {
      var self = inst, r = d.snap;
      if (!self.dialog.open) self.open({ path: 'story', own: true });
      else if (!keepThread) self.reset();
      self.updateTokens();
      var s = self.s;
      s.path = 'story'; s.saveId = d.id; s.designOk = false;
      s.sport = r.sport || s.sport; s.niche = r.niche || s.niche;
      s.idea = r.idea || null; s.logoText = r.logoText || null; s.style = r.style || null; s.sides = r.sides || null; s.frontFmt = r.frontFmt || null; s.noText = !!r.noText;
      s.color = r.color || s.color;
      s.support = r.support ? (self.supports.filter(function (sp) { return sp.h === r.support; })[0] || null) : null;
      s.faces = { front: null, back: null };
      s.history = [];
      self._fresh = false;
      return Promise.all(['front', 'back'].map(function (side) {
        var f = r.faces[side];
        if (!f) return null;
        return trimAlpha(f.src).then(function (tr) { s.faces[side] = { src: f.src, view: tr.png, w: tr.w, h: tr.h }; });
      })).then(function () {
        ['front', 'back'].forEach(function (side) { s.pos[side] = (r.pos && r.pos[side]) || { x: 0.5, y: 0.5, k: 1 }; });
        s.edit = s.faces[r.edit] ? r.edit : (s.faces.front ? 'front' : 'back');
        bk.active = d.id; renderTabs();
      });
    }
    function openTab(id) {
      var d = find(id); if (!d || id === (inst.s && inst.s.saveId)) return;
      commit(false);
      restore(d).then(function () { inst.showResult(); });
    }
    function removeTab(id) {
      var i = bk.designs.map(function (d) { return d.id; }).indexOf(id); if (i < 0) return;
      bk.designs.splice(i, 1); persist();
      var next = bk.designs[Math.min(i, bk.designs.length - 1)];
      if (next) restore(next).then(function () { inst.showResult(); }); else { bk.active = null; renderTabs(); }
    }

    /* ---------- Décliner pour une autre personne (le formulaire est dans ai-studio-v18.js) ---------- */
    function manuSides() { var f = inst.s.faces; return ['front', 'back'].filter(function (k) { return slimFace(f[k]); }); }
    function say(text) { return inst.say ? inst.say(text) : inst.bot(esc(text)); }
    inst.dtx = tx; inst.manuSides = manuSides;
    inst.canDecline = function () { var s = this.s; return !!(this.endpoint && s && s.path === 'story' && hasManu(s) && !ownFace(s)); };
    inst.dc = null;
    function launch() {
      var c = inst.dc, T = tx(), s = inst.s;
      var sides = c.side === 'both' ? ['front', 'back'] : [c.side];
      sides = sides.filter(function (k) { return slimFace(s.faces[k]); });
      if (!sides.length) return;
      if (bk.designs.length >= MAX) { say(T.max); return; }
      var text = c.kind === 'colors' ? EDIT.colors : (c.kind === 'text' ? EDIT.text(c.text.slice(0, 40)) : c.text.slice(0, 300));
      // Nouveau design = copie du design affiché, puis retouche des faces choisies
      var from = commit(true); if (!from) return;
      var d = { id: uid(), name: null, sent: false, snap: clone(from.snap) };
      d.name = c.kind === 'text' ? String(c.text).trim().slice(0, 14) : rep(T.n, { n: bk.designs.length + 1 });
      if (c.kind === 'text') d.snap.logoText = String(c.text).trim().slice(0, 40);
      bk.designs.push(d); persist();
      inst.dc = null;
      restore(d).then(function () {
        var st = inst.s; st.declining = true; st.edits = 0; st.editQueue = {};
        sides.forEach(function (k) { st.editQueue[k] = text; });
        // Les retouches de déclinaison restent offertes : on libère un crédit si la visite est à sa limite
        try { var n = JSON.parse(sessionStorage.getItem('aisRuns')) || 0; if (inst.left() <= 0) sessionStorage.setItem('aisRuns', JSON.stringify(Math.max(0, n - 1))); } catch (x) {}
        inst.bot(esc(rep(T.go, { name: d.name }))).then(function () { inst.lockThread(); inst.resultEl = null; inst.generateFaces(sides, true); });
      });
    }
    inst.launchDecline = launch;
    // Chaque face passe par la retouche de v15 avec la demande de déclinaison
    var baseApi = inst.apiLogo;
    inst.apiLogo = function (side, ref) {
      var s = this.s, q = s.editQueue;
      if (q && q[side]) {
        var f = s.faces[side];
        s.edit1 = { side: side, text: q[side], base: f && f.src };
        delete q[side];
      }
      return baseApi.apply(this, arguments);
    };

    // Résultat affiché : l'onglet actif est mis à jour (positions, tailles, retouches)
    inst.afterResult = function () { this.s.declining = false; commit(false); renderTabs(); };
    var baseResult = inst.showResult;
    inst.showResult = function () {
      var r = baseResult.apply(this, arguments);
      this.afterResult();
      return r;
    };
    inst.dialog.addEventListener('close', function () { commit(false); });
    var baseKeep = inst.saveFaces;
    inst.saveFaces = function () { commit(false); return baseKeep.apply(this, arguments); };
    // Envoi vers la fiche de personnalisation : l'onglet est marqué
    var baseHand = inst.handoff;
    inst.handoff = function () {
      var e = commit(false) || find(this.s.saveId);
      if (e) { e.sent = true; persist(); renderTabs(); }
      return baseHand.apply(this, arguments);
    };
    var baseOpen = inst.open;
    inst.open = function () { var r = baseOpen.apply(this, arguments); renderTabs(); return r; };
    var baseReset = inst.reset;
    inst.reset = function () { var r = baseReset.apply(this, arguments); if (this.s) this.s.editQueue = null; return r; };

    /* ---------- Lien de sauvegarde ---------- */
    function shareLink() {
      var T = tx(); commit(false);
      var designs = bk.designs.filter(function (d) { return d.snap.faces.front || d.snap.faces.back; });
      var cur = inst.s && hasManu(inst.s) && !ownFace(inst.s) && !find(inst.s.saveId) ? { id: uid(), name: labelOf(snap(), 1), snap: snap() } : null;
      if (cur) designs = designs.concat([cur]);
      if (!designs.length) { say(T.none); return; }
      function post(list) {
        var body = JSON.stringify({ action: 'share-save', record: { designs: list.map(function (d) { return { id: d.id, name: d.name, faces: (function (f) { var o = {}; if (f.front) o.front = f.front; if (f.back) o.back = f.back; return o; })(d.snap.faces), pos: d.snap.pos, edit: d.snap.edit, sides: d.snap.sides, frontFmt: d.snap.frontFmt, idea: d.snap.idea, logoText: d.snap.logoText, noText: d.snap.noText, sport: d.snap.sport, niche: d.snap.niche, style: d.snap.style, color: d.snap.color, support: d.snap.support }; }), active: inst.s && inst.s.saveId } });
        return fetch(inst.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
          .then(function (r) { if (!r.ok) { var e = new Error(r.status); e.status = r.status; throw e; } return r.json(); });
      }
      var sh = bar.querySelector('[data-dshare]'); if (sh) sh.disabled = true;
      say(T.wait);
      post(designs).catch(function (e) {
        // Trop lourd : on ne garde que le design affiché
        if (e && e.status === 413 && designs.length > 1) { var a = find(inst.s.saveId) || designs[0]; return post([a]); }
        throw e;
      }).then(function (j) {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = location.origin + root + '?manu_share=' + encodeURIComponent(j.id);
        var done = function () { say(rep(T.copied, { d: j.days || 90 })); };
        var fall = function () { say(rep(T.link, { u: url })); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, fall); else fall();
      }, function (e) { say(e && e.status === 413 ? T.big : (e && e.status === 501 ? T.noblob : T.fail + ' (' + ((e && e.status) || 'réseau') + ')')); })
        .then(function () { if (sh) sh.disabled = false; });
    }
    inst.shareLink = shareLink;

    /* ---------- Chargement : panier local, puis lien reçu (?manu_share=) ---------- */
    idb('readonly', function (st) { return st.get('basket'); }).then(function (b) {
      if (b && b.designs && Date.now() - (b.at || 0) < KEEP) { bk.designs = b.designs.concat(bk.designs); bk.active = b.active || null; renderTabs(); }
    }).catch(function () {});

    var m = /[?&]manu_share=([a-z0-9]{10,16})\b/.exec(location.search);
    if (m && inst.endpoint && window.fetch) {
      var id = m[1];
      try { var u = new URL(location.href); u.searchParams.delete('manu_share'); history.replaceState(null, '', u.pathname + (u.search || '') + u.hash); } catch (e) {}
      fetch(inst.endpoint + (inst.endpoint.indexOf('?') > -1 ? '&' : '?') + 'action=share&id=' + id, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          var rec = j && j.record, list = rec && rec.designs;
          if (!list || !list.length) throw new Error('empty');
          list.slice(0, MAX).forEach(function (d) {
            if (!d || !d.faces || find(d.id)) return;
            bk.designs.push({ id: d.id || uid(), name: String(d.name || '').slice(0, 14) || null, sent: false, snap: {
              faces: { front: d.faces.front || null, back: d.faces.back || null }, pos: d.pos || {}, edit: d.edit, sides: d.sides || null, frontFmt: d.frontFmt || null, idea: d.idea || '',
              logoText: d.logoText || null, noText: !!d.noText, sport: d.sport || null, niche: d.niche || null, style: d.style || null, color: d.color || 'noir', support: d.support || null } });
          });
          bk.designs.forEach(function (d, i) { if (!d.name) d.name = labelOf(d.snap, i + 1); });
          persist();
          var first = find(rec.active) || find(list[0].id) || bk.designs[bk.designs.length - 1];
          return restore(first).then(function () { inst.showResult(); });
        })
        .catch(function () {
          inst.open({ path: 'story' });
          inst.bot(esc(tx().gone));
        });
    }
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
